import { Editor, EditorTextChangeEvent } from 'primereact/editor'

interface Props {
  /**
   * id of the rich text editor container element
   * @default ""
   */
  id?: string
  /**
   * Initial/controlled value of the rich text editor (HTML string)
   * @default ""
   */
  value?: string
  /**
   * Defines whether the rich text editor should be disabled
   * @default false
   */
  disabled?: boolean
  /**
   * Height of the rich text editor in pixels
   * @default 500
   */
  height?: number
  /**
   * Called on content change. Returns editor content as HTML.
   * @default null
   */
  onChange?: (content: string) => void
}

const TOOLBAR_HEADER = (
  <span className="ql-formats">
    <select className="ql-header" defaultValue="">
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
      <option value="3">Heading 3</option>
      <option value="4">Heading 4</option>
      <option value="5">Heading 5</option>
      <option value="6">Heading 6</option>
      <option value="">Normal</option>
    </select>
    <select className="ql-size" defaultValue="">
      <option value="small">Small</option>
      <option value="">Normal</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-underline" />
    <select className="ql-align" />
    <button className="ql-list" value="ordered" />
    <button className="ql-list" value="bullet" />
    <button className="ql-link" />
    <button className="ql-image" />
    <button className="ql-clean" />
  </span>
)

const RichTextQuill = (props: Props) => {
  const { id, value, disabled = false, height = 500, onChange } = props

  const handleTextChange = (e: EditorTextChangeEvent) => {
    if (onChange) {
      onChange(e.htmlValue ?? '')
    }
  }

  return (
    <div id={id} style={{ backgroundColor: '#fff', margin: 0, padding: 0 }}>
      <Editor
        value={value ?? ''}
        readOnly={disabled}
        style={{ height }}
        headerTemplate={TOOLBAR_HEADER}
        modules={{
          clipboard: {
            matchVisual: false,
          },
        }}
        onTextChange={handleTextChange}
      />
    </div>
  )
}

export { RichTextQuill }
